import { api } from 'app/api';

export const getCommonProcessYn = ({ hspId }) => {
  return api.get(`${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/front/common/process/yn/${hspId}`);
};

export const getPtCardInfo = ({ hspId, mpiKey }) => {
  return api.get(`${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/pt-card-info/${hspId}/${mpiKey}`);
};

export const getPtCardInfoToCommonProcess = ({ hspId, mpiKey }) => {
  return api.get(
    `${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/front/common/pt-card-info/${hspId}/${mpiKey}`,
  );
};
